"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("../assets/css/custom-progress-bar.css");
var CustomProgressBar = function (_a) {
    var activeStep = _a.activeStep, stepLabels = _a.stepLabels, onStepClick = _a.onStepClick;
    return (react_1.default.createElement("div", { className: "progress-bar-container" },
        react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", position: "relative" } }, stepLabels.map(function (label, index) {
            var currentStep = index + 1;
            var isActive = activeStep >= currentStep;
            var isCompleted = activeStep > currentStep;
            return (react_1.default.createElement(react_1.default.Fragment, { key: label },
                react_1.default.createElement("div", { onClick: function () { return onStepClick(currentStep); }, className: "step-item", style: {
                        cursor: activeStep === currentStep ? "default" : "pointer",
                        zIndex: isActive ? 2 : 1,
                    } },
                    react_1.default.createElement("div", { className: "step-circle", style: {
                            backgroundColor: isCompleted
                                ? "#4caf50"
                                : isActive
                                    ? "#ffa500"
                                    : "#ccc",
                            border: isActive ? "2px solid #4caf50" : "none",
                        } }, currentStep),
                    react_1.default.createElement("span", { className: "step-label", style: {
                            color: isCompleted
                                ? "#4caf50"
                                : isActive
                                    ? "#ffa500"
                                    : "#ccc",
                        } }, label)),
                index < stepLabels.length - 1 && (react_1.default.createElement("div", { className: "step-line", style: {
                        backgroundColor: activeStep > currentStep ? "#4caf50" : "#ddd",
                    } }))));
        }))));
};
exports.default = CustomProgressBar;
